import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { FiCopy, FiArrowLeft } from "react-icons/fi";
import { FaPaperPlane } from "react-icons/fa";
import DOMPurify from "dompurify";
import { sendProductToTelegram } from "../services/telegramService";
import ChatButton from "../components/ChatButton";

export default function ProductDetails({ products, categories, telegramUserId }) {
  const { id } = useParams();
  const navigate = useNavigate();
  const [brandProducts, setBrandProducts] = useState([]);
  const [usageVisible, setUsageVisible] = useState({});

  useEffect(() => {
    if (products.length > 0) {
      const mainProduct = products.find((p) => p.id == id);
      if (mainProduct) {
        const relatedProducts = products.filter((p) => p.name === mainProduct.name);
        setBrandProducts(relatedProducts);
      }
    }
  }, [products, id]);

  if (!products.length || !categories.length) {
    return <div className="text-white text-center text-xl mt-20">Загрузка...</div>;
  }

  if (!brandProducts.length) {
    return <div className="text-white text-center text-xl mt-20">Продукт не найден</div>;
  }

  const mainProduct = brandProducts[0];
  const category = categories.find((c) => c.id == mainProduct.category_id);
  const categoryName = category ? category.name : "Неизвестная категория";

  return (
    <div className="min-h-screen bg-gradient-to-b from-[#0D1B2A] to-[#1B2433] text-white flex flex-col items-center pb-24 px-2">
      {/* Верхний navbar */}
      <div className="w-full fixed top-0 left-0 bg-[#1B2433] shadow-lg px-4 py-3 flex items-center z-50">
        <button
          onClick={() => navigate(-1)}
          className="h-14 w-14 bg-[#222C40] rounded-lg flex items-center justify-center hover:bg-opacity-40 transition shadow-lg mr-3"
        >
          <FiArrowLeft size={24} />
        </button>

        <div className="flex-1 flex items-center justify-center space-x-3 bg-[#222C40] py-3 px-4 rounded-lg shadow-lg h-14">
          <img
            src={`https://xalavach.ru/api/image.php?file=${mainProduct.avatar_image}`}
            alt={mainProduct.name}
            className="w-10 h-10 rounded-full border-2 border-white shadow-lg"
          />
          <div className="text-center">
            <h1 className="text-lg font-bold">{mainProduct.name}</h1>
            <p className="text-sm text-gray-400">{brandProducts.length} {getOfferText(brandProducts.length)}</p>
          </div>
        </div>
      </div>

      {/* Контейнер для карточек */}
      <div className="mt-24 w-[96%] max-w-md space-y-4">
        {brandProducts.map((product) => (
          <div key={product.id} className="bg-gradient-to-b from-[#1B2433] to-[#2D415A] rounded-xl shadow-2xl overflow-hidden p-4 mx-auto border border-gray-600">
            
            {/* Основное изображение */}
            <div className="rounded-t-xl overflow-hidden shadow-md">
              <img
                src={`https://xalavach.ru/api/image.php?file=${product.main_image}`}
                alt={product.name}
                className="w-full object-cover"
              />
            </div>

            {/* Блок с названием, категорией, датой */}
            <div className="p-4">
              <div className="flex items-center justify-between">
                <div className="flex items-center space-x-3">
                  <img
                    src={`https://xalavach.ru/api/image.php?file=${product.avatar_image}`}
                    alt={product.name}
                    className="w-14 h-14 rounded-full shadow-lg border-2 border-white"
                  />
                  <div>
                    <h2 className="text-xl font-bold">{product.card_title}</h2>
                    <p className="text-sm text-gray-300">{categoryName}</p>
                  </div>
                </div>
                <div className="bg-yellow-400 text-black px-3 py-1 rounded-lg shadow-md text-sm">
                  До {formatDate(product.expiry_date)}
                </div>
              </div>
            </div>

            {/* Детали карточки */}
            <div className="p-5 bg-gradient-to-b from-[#253547] to-[#34495E] rounded-xl shadow-md border border-gray-600 backdrop-blur-md">
              <p className="text-lg text-gray-300">{product.description}</p>

              {/* Промокод */}
              <div className="mt-5 p-4 bg-gray-900 text-white rounded-xl flex items-center justify-between shadow-lg border border-gray-700">
                <div className="flex flex-col">
                  <span className="text-sm text-gray-400">Твой промокод:</span>
                  <span className="font-bold text-xl tracking-wide bg-clip-text text-transparent bg-gradient-to-r from-blue-400 to-blue-600">
                    {product.promo_code}
                  </span>
                </div>
                <button
                  className="bg-gradient-to-r from-blue-500 to-blue-700 hover:from-blue-600 hover:to-blue-800 text-white px-4 py-2 rounded-full flex items-center transition duration-200 shadow-md"
                  onClick={() => navigator.clipboard.writeText(product.promo_code)}
                >
                  <FiCopy size={22} />
                </button>
              </div>
				{/* Кнопка "Скопировать и перейти на сайт" */}
				{product.website_link && (
				  <button
					onClick={() => {
					  navigator.clipboard.writeText(product.promo_code);
					  window.open(product.website_link, "_blank");
					}}
					className="w-full mt-4 bg-gradient-to-r from-purple-500 to-purple-700 hover:from-purple-600 hover:to-purple-800 
							   text-white py-3 rounded-lg text-lg font-semibold transition duration-200 
							   shadow-[0px_4px_0px_#7b2cbf] hover:shadow-[0px_2px_0px_#5a1a87] 
							   transform active:translate-y-1"
				  >
					Скопировать и перейти на сайт
				  </button>
				)}


              {/* Кнопка "Как использовать?" */}
              <div className="mt-6">
					<button
					  onClick={() => setUsageVisible((prev) => ({ ...prev, [product.id]: !prev[product.id] }))}
					  className="w-full text-center text-white bg-gradient-to-r from-blue-500 to-blue-700 py-3 rounded-lg shadow-lg text-lg font-semibold transition duration-200 hover:from-blue-600 hover:to-blue-800 px-4"
					>
					  Как использовать?
					</button>

					{usageVisible[product.id] && (
					  <div className="mt-3 bg-gray-900 p-4 rounded-lg shadow-md text-gray-300 break-words overflow-hidden">
						<p 
						  dangerouslySetInnerHTML={{ 
							__html: DOMPurify.sanitize(
							  product.usage_rules
								.replace(/•\s*(.*?)(?=\n|$)/g, '<li>$1</li>') // Превращаем маркеры `•` в <li>
								.replace(/\n{2,}/g, '</p><p>')   // Двойные переводы строк превращаем в абзацы
								.replace(/\n/g, '<br>')          // Одиночные переводы строк – в <br>
								.replace(/<li>.*?<\/li>/gs, '<ul>$&</ul>') // Оборачиваем <li> в <ul>
							) 
						  }} 
						/>
					  </div>
					)}
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Нижний navbar с кнопкой "Отправить в чат" */}
      <ChatButton brandProducts={brandProducts} telegramUserId={telegramUserId} />
    </div>
  );
}

// Функция склонения слова "предложение"
function getOfferText(count) {
  if (count % 10 === 1 && count % 100 !== 11) return "предложение";
  if (count % 10 >= 2 && count % 10 <= 4 && (count % 100 < 10 || count % 100 >= 20)) return "предложения";
  return "предложений";
}

// Функция форматирования даты (YYYY-MM-DD → 25 мая)
function formatDate(dateStr) {
  const months = [
    "января", "февраля", "марта", "апреля", "мая", "июня",
    "июля", "августа", "сентября", "октября", "ноября", "декабря"
  ];
  const [year, month, day] = dateStr.split("-");
  return `${parseInt(day)} ${months[parseInt(month) - 1]}`;
}
